// ============================================================
// PEBBLE — Custom interactions
// ============================================================

document.addEventListener('DOMContentLoaded', () => {
  initScrollReveal();
  initCounters();
  initShopNav();
  initProductHero();
  initStatFootnoteAlign();
});

// ---------- Shop nav redirect ----------
function initShopNav() {
  document.querySelectorAll('a').forEach(function(link) {
    if (link.pathname === '/collections/all' || link.pathname === '/collections') {
      link.href = '/products/pebble-water-4-pack';
    }
  });
}

// ---------- Product page quantity buttons ----------
function initProductHero() {
  document.querySelectorAll('.pebble-pdp__qty-wrap').forEach(function(wrap) {
    var input = wrap.querySelector('.pebble-pdp__qty-input');
    wrap.querySelectorAll('.pebble-pdp__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var val = parseInt(input.value, 10) || 1;
        if (btn.getAttribute('aria-label') === 'Increase quantity') {
          input.value = val + 1;
        } else if (val > 1) {
          input.value = val - 1;
        }
      });
    });
  });
}

// ---------- Scroll reveal ----------
function initScrollReveal() {
  const els = document.querySelectorAll('.pebble-reveal');
  if (!els.length) return;

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  els.forEach(el => observer.observe(el));
}

// ---------- Animated counter ----------
function initCounters() {
  const counters = document.querySelectorAll('.pebble-stat-number[data-target]');
  if (!counters.length) return;

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );

  counters.forEach(el => observer.observe(el));
}

// ---------- Stat footnote line width ----------
// The "Pebble" stat label's box (max-width: 26rem) is wider than its
// actual text, so the footnote rule's width can't be matched with CSS
// alone — measure the label's real rendered right edge instead.
function initStatFootnoteAlign() {
  const sections = document.querySelectorAll('.pebble-problem');
  if (!sections.length) return;

  function align() {
    // Stacked-stats layout: the label edge isn't a meaningful target and
    // the CSS restates the full-width rule + centered tick motif instead
    const stacked = window.matchMedia('(max-width: 750px)').matches;

    sections.forEach(section => {
      const target = section.querySelector('.pebble-problem__pebble-label-text');
      const line = section.querySelector('.pebble-problem__footnote--stat .pebble-problem__sources');
      if (!target || !line) return;

      if (stacked) {
        line.style.width = '';
        return;
      }

      // Measure from the line's own left edge, not the section's — it
      // already sits at the right x-position, only its width needs fixing
      const lineLeft = line.getBoundingClientRect().left;
      const width = target.getBoundingClientRect().right - lineLeft;
      line.style.width = Math.max(width, 0) + 'px';
    });
  }

  align();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(align);
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(align, 150);
  });
}

function animateCounter(el) {
  const target = parseInt(el.dataset.target, 10);

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    el.textContent = target;
    return;
  }

  const duration = 2200;
  const start = performance.now();

  (function step(now) {
    const progress = Math.min((now - start) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 4);
    el.textContent = Math.round(eased * target);
    if (progress < 1) requestAnimationFrame(step);
  })(start);
}
